import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from 'react';
import { connect } from 'react-redux';
import { translate } from 'i18n/jhipster-language';
import PRow from 'shared/ui/prow';
import PCol from 'shared/ui/pcol';
import { CreateHeader } from 'shared/ui/dialog-header';
import OutPutPair from 'shared/ui/output-pair';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { APP_LOCAL_DATETIME_FORMAT } from 'app/config/constants';
import moment from 'moment';
import { confirmPopup } from 'primereact/confirmpopup';
import { approveRequest } from 'shared/lib/reducers/card-unfreeze-request.reducer';
import { getCmsAccountApproverId } from 'shared/lib/cms-account-approver';
import { Toast } from 'primereact/toast';
const formatDt = (v) => (v ? moment(v).format(APP_LOCAL_DATETIME_FORMAT) : '');
const statusSeverity = (s) => {
    if (!s) {
        return null;
    }
    if (s === 'ACTIVE' || s === 'APPROVED') {
        return 'success';
    }
    if (s === 'REJECTED' || s === 'CANCELLED') {
        return 'danger';
    }
    return 'warning';
};
/** Same thunk as grid approve — bumps `cardUnfreezeRequest.updateSuccess` so list/card tabs refetch. */
const mapStateToProps = ({ cardUnfreezeRequest }) => ({
    unfreezeApproveUpdating: cardUnfreezeRequest.updating,
});
const mapDispatchToProps = {
    approveUnfreezeRequestFromDialog: approveRequest,
};
/**
 * Shared read-only detail panel for freeze and unfreeze requests (same API row shape).
 * Unfreeze adds approve-from-dialog for REQUESTED rows.
 */
const CardStatusRequestDetailsPresenter = ({ closeDialog, kind, current, unfreezeApproveUpdating, approveUnfreezeRequestFromDialog, }) => {
    const toast = useRef(null);
    const headerEntityKey = kind === 'freeze' ? 'form.cardFreezeRequest' : 'form.cardUnfreezeRequest';
    const handleApprove = (e) => {
        const requestId = current?.id;
        if (requestId == null || requestId <= 0) {
            return;
        }
        confirmPopup({
            acceptLabel: translate('entity.action.yes'),
            rejectLabel: translate('entity.action.no'),
            target: e.currentTarget,
            message: translate('entity.delete.title'),
            icon: 'pi pi-exclamation-triangle',
            accept: async () => {
                try {
                    const approverId = await getCmsAccountApproverId();
                    await approveUnfreezeRequestFromDialog(requestId, approverId);
                    toast.current?.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Request approved successfully',
                        life: 3000,
                    });
                    closeDialog();
                }
                catch (err) {
                    console.error('Approve failed', err);
                    toast.current?.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Approval failed',
                        life: 3000,
                    });
                }
            },
        });
    };
    const viewRequestedAt = formatDt(current?.requestedAt ?? undefined);
    const viewCreated = formatDt(current?.createdAt ?? undefined);
    const viewUpdated = formatDt(current?.updatedAt ?? undefined);
    const viewUnfrozenAt = formatDt(current?.unfrozenAt ?? undefined);
    return (_jsxs("div", { className: "p-mt-4", children: [kind === 'unfreeze' ? _jsx(Toast, { ref: toast }) : null, _jsx(PCol, { children: _jsx(PRow, { justify: "between", children: _jsx(CreateHeader, { headername: translate('form.action.detail', {
                            entity: translate(headerEntityKey),
                        }) }) }) }), _jsxs(PCol, { children: [_jsxs(PRow, { children: [_jsx(OutPutPair, { labelMd: "2", valueMd: "4", label: "form.cardHolderName", value: current?.card?.cardHolderName ?? '' }), _jsx(OutPutPair, { labelMd: "2", valueMd: "4", label: "form.maskedPan", value: current?.card?.maskedPan ?? '' }), kind === 'freeze' ? (_jsx(OutPutPair, { labelMd: "2", valueMd: "4", label: "form.freezeReason", value: current?.reason ?? '' })) : (_jsxs(_Fragment, { children: [_jsx(OutPutPair, { labelMd: "2", valueMd: "4", label: "form.reasonLabel", value: current?.reason ?? '' }), _jsx(OutPutPair, { labelMd: "2", valueMd: "4", label: "form.unfreezeReason", value: current?.unfreezeReason ?? '' })] })), _jsx(OutPutPair, { labelMd: "2", valueMd: "4", label: "form.sourceChannel", value: current?.sourceChannel ?? '' }), _jsx(OutPutPair, { labelMd: "2", valueMd: "4", label: "form.performedBy", value: current?.performedBy ?? '' }), kind === 'unfreeze' ? (_jsx(OutPutPair, { labelMd: "2", valueMd: "4", label: "form.unfrozenBy", value: current?.unfrozenBy ?? '' })) : null, _jsx(OutPutPair, { labelMd: "2", valueMd: "4", label: "form.status", children: current?.status ? (_jsx(Tag, { value: current.status, severity: statusSeverity(current.status) ?? 'info' })) : null }), _jsx(OutPutPair, { labelMd: "2", valueMd: "4", label: "form.requestedAt", value: viewRequestedAt }), kind === 'unfreeze' ? (_jsx(OutPutPair, { labelMd: "2", valueMd: "4", label: "form.unfrozenAt", value: viewUnfrozenAt })) : null, _jsx(OutPutPair, { labelMd: "2", valueMd: "4", label: "form.notes", value: current?.notes ?? '' }), _jsx(OutPutPair, { labelMd: "2", valueMd: "4", label: "form.createdDate", value: viewCreated }), _jsx(OutPutPair, { labelMd: "2", valueMd: "4", label: "form.updatedAt", value: viewUpdated })] }), kind === 'freeze' ? (_jsx(PRow, { className: "p-mt-3", children: _jsx(Button, { type: "button", label: translate('entity.action.close'), onClick: closeDialog, className: "p-button-danger p-ml-2" }) })) : (_jsxs(PRow, { className: "p-mt-3 d-flex justify-content-end", children: [_jsx(Button, { type: "button", label: translate('entity.action.close'), onClick: closeDialog, className: "p-button-danger p-ml-2" }), current?.status === 'REQUESTED' ? (_jsx(Button, { type: "button", label: translate('form.action.approve'), onClick: handleApprove, className: "p-button-primary p-ml-2", loading: unfreezeApproveUpdating, disabled: unfreezeApproveUpdating })) : null] }))] })] }));
};
export default connect(mapStateToProps, mapDispatchToProps)(CardStatusRequestDetailsPresenter);
